export default __webpack_public_path__ + "static/media/bg5_m.464ffe61.png";